module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_2_1.b1aa9c90.png";